import React, { useRef, useEffect } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import { connect } from 'react-redux';
import SupportLandingPage from './SupportLandingPage';
import Echostream from './echostream/Echostream';
import Decoder from './echostream/Decoder';

import Db from './db/Db';
import FkRepair from './db/FkRepair';
import AsciiRepair from './db/AsciiRepair';
import QuerySPA from './db/querycatalog/QuerySPA';

/**
 * The function to display the appropriate components for users.
 * @description - React Router takes the url paths and displays the appropriate components. If the route is /users/ it will display the list of users. If the Route is /users/ followed by a number, it will display the full view of that user. If it's /users/edit/ followed by a number, it will display the edit view for that user
 */

export function UnconnectedSupport(props) {
  const location = useLocation();

  const previousLocation = useRef(location);

  if (
    location &&
    location.state &&
    location.state.modal
  ) {
    if (location.pathname === '/support/alert/:id/edit/') {
      previousLocation.current = { pathname: '/users/' };
    }
  }

  useEffect(() => {
    // props.dispatch(getSiteInfo());
  }, []); // eslint-disable-line

  useEffect(() => {
    if (location) {
      if (location.state && location.state.modal) {
        previousLocation.current = { pathname: '/support/' };
      } else {
        previousLocation.current = location;
      }
    }
  }, [props, location]);

  let isModal = false;
  if (location && location.state && location.state.modal) {
    isModal = true;
  }

  return (
    <React.Fragment>
      <Routes location={isModal ? previousLocation.current : location}>
        <Route
          path="echostream/decode/"
          element={<Decoder />}
          data-test="view-alert-device"
        />
        <Route
          path="echostream/"
          element={<Echostream />}
          data-test="view-alert-device"
        />

        <Route
          path="db/asciirepair/"
          element={<AsciiRepair />}
          data-test="view-alert-device"
        />
        <Route
          path="db/fkrepair/"
          element={<FkRepair />}
          data-test="view-alert-device"
        />

        {/* The following routes are for the Query Catalog */}
        <Route
          path="db/query/*"
          element={<QuerySPA />}
          data-test="query-page"
        />

        <Route
          path="db/"
          element={<Db />}
          data-test="view-alert-device"
        />

        <Route path="/" element={<SupportLandingPage />} />
      </Routes>
      {/* <Route
        path="/support/alert/:id/edit/"
        component={EditAlertDevice}
        data-test="edit-alert-device"
      /> */}
    </React.Fragment>
  );
}
export default connect()(UnconnectedSupport);
